module.exports = __webpack_public_path__ + "static/media/canadian.c846ac5e.png";